import { createListReducer } from '../../../common/services/reducerCreator';

export default createListReducer('TOURNAMENTS');
